import { inject, Injectable } from '@angular/core';

import {
    MapModalSelectionModeEnum,
    SelectionService,
} from '@connect-services/client/services/map/selection/selection.service';
import { MapModal, MapModalService } from '@connect-services/client/services/map-modal.service';

@Injectable({
    providedIn: 'root',
})
export class FieldInterventionSelectionModalService {
    private readonly mapModalService = inject(MapModalService);
    private readonly selectionService = inject(SelectionService);

    public closeSelectionModal(): void {
        this.mapModalService.close(MapModal.FILTER);
        this.mapModalService.close(MapModal.SELECTION);

        this.selectionService.isFilterModalOpen.set(false);
        this.selectionService.isSelectionActive.set(false);
        this.selectionService.setModalMode(MapModalSelectionModeEnum.SELECTION);
    }

    public openSelectionModal(): void {
        if (this.selectionService.isFilterModalOpen()) {
            return;
        }

        this.selectionService.isFilterModalOpen.set(true);
        this.selectionService.setModalMode(MapModalSelectionModeEnum.FIELD_INTERVENTION);
        this.mapModalService.open(MapModal.FILTER);
    }
}
